import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "mdi",
  },
  theme: {
    themes: {
      light: {
        primary: "#212121",
        secondary: "#FFFFFF",
        anchor: "#212121",
        error: "#F44336",
      },
    },
  },
});
